import axios from "axios";
import Url from "../../../ApiConfig";
import { Dispatch } from "react";
import {
  InactiveCorporatePackagesActionTypes,
  INACTIVE_CORPORATE_LIST_FAIL,
  INACTIVE_CORPORATE_LIST_LOADING,
  INACTIVE_CORPORATE_LIST_SUCCESS,
} from "./ActionTypes";
import { getInactiveCorporateListActions } from "./Actions";
import { setupInterceptorsTo } from "../../Authentication/Interceptors";
import { headers } from "../../../component/Utility";

// Active Corporate List API
export const getInactiveCorporatePackageList = (body: object) => {
  return function (dispatch: Dispatch<InactiveCorporatePackagesActionTypes>) {
    dispatch({
      type: INACTIVE_CORPORATE_LIST_LOADING,
    });
    setupInterceptorsTo(axios)
      .post(
        Url.baseUrl +
          `/paymentapp/api/corporatePackageForAdmin/corporatePackageList`,
        body,
        { headers: headers }
      )
      .then((res) => {
        let inactiveCorporatePackageList = res.data.corporatePackageList;
        dispatch(getInactiveCorporateListActions(inactiveCorporatePackageList));
        dispatch({
          type: INACTIVE_CORPORATE_LIST_SUCCESS,
          payload: inactiveCorporatePackageList,
        });
      })
      .catch((error) => {
        dispatch({
          type: INACTIVE_CORPORATE_LIST_FAIL,
        });
      });
  };
};
